import { identifyUser } from "@/modules/shared/utils/posthog";

export type MemberPersonProperties = {
  email: string;
  accountStatus?: "trial" | "paid";
};

// Members reach Lotus without an auth user id, so PostHog identifies them by
// their work email. Caladan aliases the same email onto its userId person.
export function identifyMember({
  email,
  accountStatus,
}: MemberPersonProperties): void {
  const personProperties: Record<string, string> = {
    email,
    last_seen_at: new Date().toISOString(),
  };

  if (accountStatus) {
    personProperties.account_status = accountStatus;
  }

  identifyUser(email, personProperties);
}
